module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<label class="b-input">\n	<span class="js-widget"  onclick=\'return new Widgets.Select({ bindingProperty: "reasonCode" , values: "' + reasonCodes + '" , label: L10N.get("b2b.costCodes.reasonCode.code") })\'></span>\n</label>';

}
return __p
}